import { Pipe, PipeTransform } from '@angular/core';
import { SearchAsset } from 'src/app/modules/standard/v1';
import { PreviewMode, UtilityService } from '../services/utility.service';

// Pure pipe: the cache-busted url is recomputed only when the asset reference changes
// (i.e. on a data reload), not on every change detection cycle.
@Pipe({ name: 'searchPreview' })
export class SearchPreviewPipe implements PipeTransform {
  constructor(private utilityService: UtilityService) { }

  transform(asset: SearchAsset, mode: PreviewMode = PreviewMode.Thumbnail): string {
    return this.utilityService.getSearchFilePreviewUrl(asset, mode, true);
  }
}
